/* Footer – Sacred Modern Design
 * Dark footer with logo, links, and legal info
 */
import { IMAGES, NAV_ITEMS } from "@/lib/constants";
import { useI18n } from "@/contexts/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-[oklch(0.14_0.02_280)] py-16 border-t border-[oklch(0.25_0.02_280)]">
      <div className="container">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <img
              src={IMAGES.logo}
              alt="AYU Logo"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-[oklch(0.6_0.02_80)] leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
              {t("landing.footer.description")}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-bold text-[oklch(0.85_0.01_80)] mb-4 text-sm tracking-wide uppercase">
              {t("landing.footer.navigation")}
            </h4>
            <ul className="space-y-2">
              {NAV_ITEMS.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-[oklch(0.6_0.02_80)] hover:text-[oklch(0.78_0.11_85)] transition-colors"
                    style={{ fontFamily: "var(--font-body)" }}
                  >
                    {t(item.labelKey as any)}
                  </a>
                </li>
              ))}
            </ul>

            <h4 className="font-bold text-[oklch(0.85_0.01_80)] mb-4 mt-6 text-sm tracking-wide uppercase">
              {t("landing.footer.mehr")}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/funnel" className="text-sm text-[oklch(0.6_0.02_80)] hover:text-[oklch(0.78_0.11_85)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>
                  {t("landing.footer.assessment")}
                </a>
              </li>
              <li>
                <a href="/erleben" className="text-sm text-[oklch(0.6_0.02_80)] hover:text-[oklch(0.78_0.11_85)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>
                  {t("landing.footer.ayuErlebenDemo")}
                </a>
              </li>
              <li>
                <a href="/ayu-erleben" className="text-sm text-[oklch(0.6_0.02_80)] hover:text-[oklch(0.78_0.11_85)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>
                  {t("landing.footer.ayuErleben")}
                </a>
              </li>
              <li>
                <a href="/video" className="text-sm text-[oklch(0.6_0.02_80)] hover:text-[oklch(0.78_0.11_85)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>
                  {t("landing.footer.video")}
                </a>
              </li>
              <li>
                <a href="/termin" className="text-sm text-[oklch(0.6_0.02_80)] hover:text-[oklch(0.78_0.11_85)] transition-colors" style={{ fontFamily: "var(--font-body)" }}>
                  {t("landing.footer.terminBuchen")}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Legal */}
          <div>
            <h4 className="font-bold text-[oklch(0.85_0.01_80)] mb-4 text-sm tracking-wide uppercase">
              {t("landing.footer.kontakt")}
            </h4>
            <ul className="space-y-2 text-sm text-[oklch(0.6_0.02_80)]" style={{ fontFamily: "var(--font-body)" }}>
              <li>
                <a href="mailto:office@ayu-rveda.ai" className="hover:text-[oklch(0.78_0.11_85)] transition-colors">
                  office@ayu-rveda.ai
                </a>
              </li>
              <li>
                <a href="https://www.ayu-rveda.com" target="_blank" rel="noopener noreferrer" className="hover:text-[oklch(0.78_0.11_85)] transition-colors">
                  www.ayu-rveda.com
                </a>
              </li>
            </ul>

            <h4 className="font-bold text-[oklch(0.85_0.01_80)] mb-3 mt-6 text-sm tracking-wide uppercase">
              {t("landing.footer.rechtliches")}
            </h4>
            <ul className="space-y-2 text-sm text-[oklch(0.6_0.02_80)]" style={{ fontFamily: "var(--font-body)" }}>
              <li>
                <a href="/datenschutz" className="hover:text-[oklch(0.78_0.11_85)] transition-colors">
                  {t("landing.footer.datenschutz")}
                </a>
              </li>
              <li>
                <a href="/impressum" className="hover:text-[oklch(0.78_0.11_85)] transition-colors">
                  {t("landing.footer.impressum")}
                </a>
              </li>
              <li>
                <a href="/agb" className="hover:text-[oklch(0.78_0.11_85)] transition-colors">
                  {t("landing.footer.agb")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="gold-line mb-8" />
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[oklch(0.5_0.02_80)]" style={{ fontFamily: "var(--font-body)" }}>
            &copy; {new Date().getFullYear()} {t("landing.footer.copyright")}
          </p>
          <p className="text-xs text-[oklch(0.4_0.02_80)]" style={{ fontFamily: "var(--font-body)" }}>
            {t("landing.footer.disclaimer")}
          </p>
        </div>
      </div>
    </footer>
  );
}
